module.exports = __webpack_public_path__ + "img/图1-28斜度符号和锥度符号.a2f2a538.png";